import { importsActions } from '@sonar-software/sonar-imports';
import { SyncStatusNotification } from './notifications';
import React, { useCallback } from 'react';
import { useAction, useAuthToken, useInterval, useOnMount } from '@hooks';
const REFRESH_INTERVAL = 10 * 1000;
export const SalesforceSyncWatcher = ({ showNotifications }) => {
    const { organizationId } = useAuthToken();
    const getLatest = useAction(importsActions.requestGetImportsLatestSalesforce);
    const getLatestIfAble = useCallback(() => {
        if (!organizationId) {
            return;
        }
        getLatest();
    }, [getLatest, organizationId]);
    useOnMount(() => {
        getLatestIfAble();
    });
    useInterval(() => {
        getLatestIfAble();
    }, REFRESH_INTERVAL);
    if (!showNotifications) {
        return null;
    }
    return React.createElement(SyncStatusNotification, null);
};
